import type { Component } from "vue";

import type { ViewType } from "@core/composables/state/useNavigation";

export type AdminMenuKey =
  | "statistics"
  | "telemetry"
  | "applications"
  | "users"
  | "organizations"
  | "audits"
  | "exports"
  | "remit"
  | "vehicleRegistry"
  | "manualApproval"
  | "camerasOverview"
  | "trafficControl"
  | "system"
  | "youparkCustomers";

export type AdminMenuAction = "navigate-customers" | "navigate-customers-remit";

type AdminMenuItemBase = {
  key: AdminMenuKey;
  icon: Component;
  visible: boolean;
};

export type AdminMenuItem =
  | (AdminMenuItemBase & { route: ViewType; activeViews: ViewType[]; action?: never })
  | (AdminMenuItemBase & { action: AdminMenuAction; route?: never; activeViews?: never });

export function sortAdminMenuItemsByLabel<T extends { key: AdminMenuKey }>(
  items: readonly T[],
  translate: (key: string) => string
): T[] {
  return [...items].sort((a, b) => translate(`nav.${a.key}`).localeCompare(translate(`nav.${b.key}`), "nb"));
}
